<div class="help-action-container">
  <ng-casto-button class="secondary" [faIcon]="faQuestion" (click)="openTips()"></ng-casto-button>
</div>
